/* tslint:disable */
/* eslint-disable */
export enum RabatTypeEnum {
  NoRabat = 'NoRabat',
  KontantEngangsRabat = 'KontantEngangsRabat',
  ProcentEngangsRabat = 'ProcentEngangsRabat',
  RecurringKontantRabat = 'RecurringKontantRabat',
  RecurringProcentRabat = 'RecurringProcentRabat'
}
